import { UserManager, WebStorageStateStore } from 'oidc-client';

const getRedirectUri = () => {
  return `${window.location.origin}/signin-oidc`;
};

const getPostLogoutRedirectUri = () => {
  return `${window.location.origin}/signout-callback-oidc`;
};

const settings = {
  authority: 'https://auth.yiqifei.com',
  client_id: '745748667101253',
  client_secret: 'AKNTDIyqcXrX1EOFvuMir9rReXcY4WL9',
  redirect_uri: getRedirectUri(),
  post_logout_redirect_uri: getPostLogoutRedirectUri(),
  response_type: 'code',
  scope: 'openid profile',
  automaticSilentRenew: true,
  loadUserInfo: true,
  // 明确使用 localStorage 来持久化用户信息
  userStore: new WebStorageStateStore({ store: window.localStorage })
};

export const userManager = new UserManager(settings);

export default {
  userManager,
  
  // 登录
  login() {
    return userManager.signinRedirect();
  },
  
  // 处理登录回调
  async handleCallback() {
    try {
      const user = await userManager.signinRedirectCallback();
      return user;
    } catch (error) {
      console.error('登录回调处理失败:', error);
      throw error;
    }
  },
  
  // 登出
  logout() {
    // signoutRedirect 会自动处理清除本地数据并重定向到认证服务器
    return userManager.signoutRedirect();
  },
  
  // 处理登出回调
  async handleSignoutCallback() {
    try {
      await userManager.signoutRedirectCallback();
    } catch (error) {
      console.error('登出回调处理失败:', error);
      throw error;
    }
  },
  
  // 获取当前用户
  async getUser() {
    try {
      const user = await userManager.getUser();
      return user;
    } catch (error) {
      console.error('获取用户信息失败:', error);
      return null;
    }
  }
};

